/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {KTIcon, toAbsoluteUrl} from '../../../_metronic/helpers'
import {Link, useNavigate} from 'react-router-dom'
import {useLocation} from 'react-router'
import {fetchData, getEncryptedRoute, toasterrormsg, useMenuIdPermissions} from '../../../reusable'
import Swal from 'sweetalert2'
import {Tr} from '../../../_metronic/i18n/Tr'

const TourPackageDetailsHeader: React.FC = () => {
  let t = Tr()
  const tmp = sessionStorage.getItem('admin')
  const adminId = tmp ? JSON.parse(tmp)?.adminId ?? '' : ''
  const location = useLocation()
  const {menuId, menuIdEdit, menuIdDelete} = useMenuIdPermissions()

  const tourpackageId = (location.state as any)?.tourpackageId || ''
  const [tourPackageDetails, setTourPackageDetails] = useState([])
  const navigate = useNavigate()
  // Tour Package Details api call
  const tourPackageDetailsApiCall = async () => {
    var param: any = {
      tourpackageId: tourpackageId,
    }
    var response: any = await fetchData('vendor/public/tourPackageDetails', param)

    if (response.status == '200') {
      setTourPackageDetails(response.data)
    } else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    tourPackageDetailsApiCall()
  }, [])

  const rejectconfirmation = async (status: any, id: any) => {
    Swal.fire(
      status == '2'
        ? {
            title: t('Are You Sure? You Want to Reject This Tour Package Documemt.'),
            icon: 'warning',
            showCancelButton: true,
            input: 'text',
            inputLabel: 'Reason',
            inputPlaceholder: t('Enter Reject Reason'),
            inputValidator: (value) => {
              // Validate input here
              if (!value) {
                return 'Reject Reason Required!'
              }
              if (value.length > 150) {
      return t('Reject Reason cannot exceed 150 characters!')
    }
            },
          }
        : {
            title: t('Are You Sure? You Want to Approve This Tour Package Document.'),
            icon: 'warning',
            showCancelButton: true,
          }
    ).then(async (result) => {
      if (result.isConfirmed) {
        const inputValue = result.value
        if (status == '1') {
          var dataObj: any = {
            id: id,
            status: status,
            type: 'tourpackage',
            adminId: adminId,
          }

          if (status == '2') {
            dataObj.reason = inputValue
          }

          var res = await fetchData('admin/approverejecthotel', dataObj)

          if (res.status === 200) {
            Swal.fire({
              title: t('Status Change Successfully !'),
              icon: 'success',
            }).then((res) => {
              if (res.isConfirmed) {
                tourPackageDetailsApiCall()
              }
            })
          } else {
            Swal.fire({
              title: 'Something went Wrong !',
              icon: 'error',
            })
          }
        } else if (inputValue !== undefined && inputValue.trim() !== '' && status == '2') {
          var dataObj: any = {
            id: id,
            status: status,
            type: 'tourpackage',
                        adminId: adminId,

          }

          if (status == '2') {
            dataObj.reason = inputValue
          }

          var res = await fetchData('admin/approverejecthotel', dataObj)

          if (res.status === 200) {
            Swal.fire({
              title: t('Status Change Successfully !'),
              icon: 'success',
            }).then((res) => {
              if (res.isConfirmed) {
                tourPackageDetailsApiCall()
              }
            })
          } else {
            Swal.fire({
              title: 'Something went Wrong !',
              icon: 'error',
            })
          }
        } else {
          // If input value is not valid, show error message
          Swal.fire({
            title: t('Invalid Input!'),
            text: t('Please enter a valid reason.'),
            icon: 'error',
          })
        }
      }
    })
  }

  const confirmdelete = (tourpackageId: any) => {
    Swal.fire({
      title: t('Are you sure?'),
      text: t('You Want To Delete'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then(async (result) => {
      if (result.isConfirmed) {
        var param = {
          tourpackageId: tourpackageId,
          adminId: adminId,
        }
        var res = await fetchData('vendor/public/deleteTourPackage', param)

        if (res.status == '200') {
          navigate(getEncryptedRoute('../viewtourpackages/', { menuId: menuId }))
        } else {
          toasterrormsg(res.message)
        }
      }
    })
  }
  return (
    <>
      {tourPackageDetails.map((tourPackage: any, index: any) => {
        var imageUrl = ''
        var totalImage = ''
        if (tourPackage['images'].length != 0) {
          imageUrl = tourPackage['images'][0].mediaPath
          totalImage = '+' + (tourPackage['images'].length - 1)
        } else {
          imageUrl = toAbsoluteUrl('/media/avatars/300-1.jpg')
          totalImage = ''
        }
        return (
          <div className='card mb-5 mb-xl-10' key={index}>
            <div className='card-body pt-9 pb-0'>
              <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
                <div className='me-7 mb-4'>
                  <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
                    <img src={imageUrl} alt='vendor avatar' />
                    {totalImage ? (
                      <div className='position-absolute translate-middle top-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-40px w-40px text-white fw-bold fs-4 p-1'>
                        {totalImage}
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </div>

                <div className='flex-grow-1'>
                  <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                    <div className='d-flex flex-column'>
                      <div className='d-flex align-items-center mb-2'>
                        <div className='text-gray-800 fs-2 fw-bolder me-1'>
                          {tourPackage['primaryLanguage'] == 'English'
                            ? tourPackage['en_agencyName']
                            : tourPackage['primaryLanguage'] == 'Russian'
                            ? tourPackage['ru_agencyName']
                            : tourPackage['primaryLanguage'] == 'Uzbek'
                            ? tourPackage['uz_agencyName']
                            : ''}
                        </div>
                      </div>

                      <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                        <div className='d-flex align-items-center text-gray-400 me-5 mb-2'>
                          <KTIcon iconName='geolocation' className='fs-4 me-1' />
                          {t('Location :')} {tourPackage['location']}
                        </div>
                        <div className='d-flex align-items-center text-gray-400 me-5 mb-2'>
                          <KTIcon iconName='sms' className='fs-4 me-1' />
                          {tourPackage['email']}
                        </div>
                        <div className='d-flex align-items-center text-gray-400 me-5 mb-2'>
                          <KTIcon iconName='phone' className='fs-4 me-1' />
                          {tourPackage['phoneNo']}
                        </div>
                        <div className='mt-5'>
                          {tourPackage['businessInfostatus'] == 0 && (
                            <>
                              {menuIdEdit ? (
                                <button
                                  className='btn btn-success btn-sm me-3'
                                  onClick={() => {
                                    rejectconfirmation('1', tourPackage['tourpackageId'])
                                  }}
                                >
                                  {t('Approve')}
                                </button>
                              ) : (
                                ''
                              )}
                              {menuIdEdit ? (
                                <button
                                  className='btn btn-danger btn-sm me-3'
                                  onClick={() => {
                                    rejectconfirmation('2', tourPackage['tourpackageId'])
                                  }}
                                >
                                  {t('Reject')}
                                </button>
                              ) : (
                                ''
                              )}
                            </>
                          )}
                          {menuIdDelete ? (
                            <button
                              className='btn btn-sm me-3'
                              style={{backgroundColor: 'orange', color: 'white'}}
                              onClick={() => confirmdelete(tourPackage['tourpackageId'])}
                            >
                              {t('Delete')}
                            </button>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    </div>
                  </div>{' '}
                  <div className='d-flex flex-wrap flex-stack'>
                    <div className='d-flex flex-column flex-grow-1 pe-8'>
                      <div className='d-flex flex-wrap'></div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='d-flex overflow-auto h-55px'>
                <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
                  <li className='nav-item'>
                    <Link
                      className={
                        `nav-link text-active-primary me-6 ` +
                        (location.pathname === '/tourpackageoverview/' && 'active')
                      }
                      to={getEncryptedRoute('../tourpackageoverview/', {menuId: menuId})}
                      state={{tourpackageId: tourpackageId}}
                    >
                      {t('All Details')}
                    </Link>
                  </li>

                  <li className='nav-item'>
                    <Link
                      className={
                        `nav-link text-active-primary me-6 ` +
                        (location.pathname === '/viewtouslist/' && 'active')
                      }
                      to={getEncryptedRoute('../viewtouslist/', {menuId: menuId})}
                      state={{tourpackageId: tourpackageId}}
                    >
                      {t('Tours')}
                    </Link>
                  </li>
                  <li className='nav-item'>
                    <Link
                      className={
                        `nav-link text-active-primary me-6 ` +
                        (location.pathname === '/viewtourpackagecontract/' && 'active')
                      }
                      to={getEncryptedRoute('../viewtourpackagecontract/', {menuId: menuId})}
                      state={{tourpackageId: tourpackageId, vendorId: tourPackage['vendorId']}}
                    >
                      {t('Contract')}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )
      })}
    </>
  )
}

export {TourPackageDetailsHeader}
